export default __webpack_public_path__ + "037a32381d57b921299a2fb1c4743cd3.png";